import React from "react";
import PropTypes from "prop-types";
import * as Table from "reactabular-table";
import { injectIntl, intlShape } from "react-intl";

import { genUnitValueFormatter } from "../tabellen/Tabellen";
import { genComponentFormatterLong } from "../model/util/Components";
import { compressorComponentToI18nKey, compressorIsInstalled } from "../model/Kompressor";

import { sortWartungen } from "./SortWartungen";

const KompressorWartungTabelle = props => {
	const rows = props.data.filter(
		m => compressorIsInstalled(props.compressors[m.cindex]) &&
		m.interval_h > 0).sort(sortWartungen).reverse();
	return (
		<Table.Provider columns={[{
			property: "cindex",
			cell: { formatters: [ genComponentFormatterLong(props.compressors, props.intl) ] },
			header: {
				label: props.intl.formatMessage({ id: "Compressor" })
			}
		}, {
			property: "component",
			cell: { formatters: [ value => props.intl.formatMessage({
				id: compressorComponentToI18nKey(value) || "unknown"
			}) ] },
			header: {
				label: props.intl.formatMessage({ id: "Component" })
			}
		}, {
			property: "interval_h",
			cell: { formatters: [ genUnitValueFormatter("hours", props.units, props.intl, true) ]},
			header: {
				label: props.intl.formatMessage({ id: "Interval" })
			}
		}, {
			property: "remaining_h",
			cell: { formatters: [ genUnitValueFormatter("hours", props.units, props.intl, true) ]},
			header: {
				label: props.intl.formatMessage({ id: "Time to next maintenance" })
			}
		}]}>
			<Table.Header />
			<Table.Body rows={rows} rowKey={({ rowData }) => rowData.cindex * 1000 + rowData.component} />
		</Table.Provider>
	);
};

KompressorWartungTabelle.propTypes = {
	data: PropTypes.arrayOf(PropTypes.object).isRequired,
	compressors: PropTypes.arrayOf(PropTypes.object).isRequired,
	units: PropTypes.object.isRequired,
	intl: intlShape.isRequired
};

export default injectIntl(KompressorWartungTabelle);
